// en
export default {
  en: {
    model: {
      auth: {
        activation_succeed: 'Your account has been activated successfully',
        activation_failed:
          'The activation code is invalid. Please contact us via info@quescreen.com for further assistance.',
        session_timed_out: 'Your session has timed out',
      },
      candidate_profile: {
        navmenu: 'Your Profile',
      },
      booking: {
        singular: 'Booking',
        plural: 'Bookings',
        name: '@:model.booking.singular Name',
        publish: 'Publish @:model.booking.singular',
        update: 'Update @:model.booking.singular',
        list: '@:model.booking.singular History',
        create: 'Make a new @:model.booking.singular',
      },
      booking_candidate: {
        candidate_list: 'History',
        candidate_list_business: 'Candidate Reports',
        candidate_list_admin: 'Candidate Reports',
      },
      business: {
        singular: 'Business',
        plural: 'Businesses',
        name: '@:model.business.singular Name',
        publish: 'Publish @:model.business.singular',
        update: 'Update @:model.business.singular',
        my: 'My @:model.business.singular',
        details: '@:model.business.singular Details',
        apply_for_credit_check: 'Apply Credit Account',
        api_credentials: 'API Credentials',
        app_name: 'APP Name',
        client_id: 'Client ID',
        client_secret: 'Client Secret',
      },
      risk_profile: {
        singular: 'Risk Profile',
        plural: 'Risk Profiles',
        name: '@:model.risk_profile.singular Name',
        custom_job_role_name: 'Customise Job Role Name',
        publish: 'Publish @:model.risk_profile.singular',
        update: 'Update @:model.risk_profile.singular',
        create: 'Create a @:model.risk_profile.singular',
        list: '@:model.risk_profile.singular History',
      },
      risk_profile_template: {
        singular: 'Risk Profile Template',
        plural: 'Risk Profile Templates',
        name: '@:model.risk_profile_template.singular Name',
        publish: 'Publish @:model.risk_profile_template.singular',
        update: 'Update @:model.risk_profile_template.singular',
      },
      question_group: {
        singular: 'Question Group',
        plural: 'Question Groups',
      },
      credit: {
        singular: 'Credit',
        plural: 'Credits',
        noun:
          'no @:model.credit.singular | @:model.credit.singular | @:model.credit.plural',
        quescreen_credit:
          'no @:model.credit.singular | 1 @:model.credit.singular | {n} @:model.credit.plural',
        add: 'Buy @:model.credit.singular',
        credit_remain: '@:model.credit.plural Remaining',
        credit_require: '@:model.credit.plural Required',
        credit_consume: '@:model.credit.plural Consumed',
        credit_range: '@:model.credit.singular Range',
        credit_amount: '@:model.credit.singular Amount',
        visitscreen: {
          singular: 'Visitscreen',
          plural: 'Visitscreens',
          noun:
            'no @:model.credit.visitscreen.singular | @:model.credit.visitscreen.singular | @:model.credit.visitscreen.plural',
          remain_visitscreen: 'Remaining @:model.credit.visitscreen.plural',
          add: 'Add @:model.credit.visitscreen.plural',
        },
        top_up: 'Top Up',
        consume: 'Consume',
        report: '@:model.credit.singular Report',
      },
      payment: {
        singular: 'Payment',
        plural: 'Payments',
        noun:
          'no @:model.payment.singular | @:model.payment.singular | @:model.payment.plural',
        filter: '@:common_word.filter @:model.payment.plural',
        your: '@:common_word.your @:model.payment.plural',
        list: '@:model.payment.singular List',
        detail: '@:model.payment.singular Details',
        price: 'Price',
        price_range: '@:model.payment.price Range',
        created_at: '@:model.payment.singular Date',
        fail: '@:model.payment.singular Failed',
        receipt: 'Receipt',
        id: '@:model.payment.singular ID',
        bill_to: 'Billed to',
        product_name: 'Product Name',
        method: 'Payment Method',
      },
      service_order: {
        singular: 'Service Order',
        plural: 'Service Orders',
      },
      purchase_quescreen: {
        singular: 'Purchase Quescreen',
        purchase: 'Purchase',
        new: 'Purchase Credits',
        history: 'Purchase History',
        report: 'Financial Report',
      },
      service_candidate: {
        singular: 'Service Candidate',
        plural: 'Service Candidates',
      },
      business_credit_check: {
        singular: 'Business Credit Check',
        plural: 'Business Credit Checks',
      },
      user_preference: {
        ghc_booking_candidate_status_enabled_label:
          'Show Booking Candidate Status for General Health Check',
        monthly_booking_summary_email_enabled_label:
          'Receive Monthly Booking Summary Emails',
        booking_reminder_email_enabled_label:
          'Receive email notifications of incomplete bookings',
        ghc_booking_candidate_status_enabled_hint:
          'If you have privacy concerns and wish to conceal individual progress status for general health checks, you can disable this option.',
        monthly_booking_summary_email_enabled_hint:
          'If you prefer not to receive monthly booking summary emails, you can disable this option.',
        booking_reminder_email_enabled_hint:
          'If you prefer not to receive email notifications of incomplete bookings, you can disable this option.',
      },
      feedback: {
        title: 'Help us improve!',
        body: 'How satisfied were you with your experience today?',
        rating_1: 'Very unsatisfied',
        rating_2: 'Unsatisfied',
        rating_3: 'Neutral',
        rating_4: 'Satisfied',
        rating_5: 'Very satisfied',
      },
    },
    common_word: {
      dashboard: 'Dashboard',
      first_name: 'First Name',
      last_name: 'Last Name',
      email: 'Email',
      mobile_number: 'Mobile Number',
      date_of_birth: 'Date of Birth',
      username: 'Username',
      admin: 'Admin',
      success_update: 'Your changes have been saved.',
      quescreen_history: 'Booking History',
      users: 'Users',
      update: 'Update',
      cancel: 'Cancel',
      submit: 'Submit',
    },
  },
};
